import { Seo } from "../components/Seo";
import { MaskedLines } from "../components/motion";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { QuoteWizard } from "../components/QuoteWizard";
import { SITE, orgSchema, breadcrumbSchema } from "../data/site";

const trail = [["Home", "/"], ["Get a quote", "/contact"]];

export default function Contact() {
  return (
    <>
      <Seo
        title="Get a Free Payroll Quote | ABSLpay"
        description="Request a same-day written payroll quote from ABSLpay. Free setup and migration from Gusto, ADP, Paychex or QuickBooks Payroll."
        path="/contact"
        jsonLd={[orgSchema(), breadcrumbSchema(trail)]}
      />
      <Breadcrumbs trail={trail} />

      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,#ECFDF5_0%,transparent_50%)]" aria-hidden="true" />
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-20 lg:pt-16">
          <MaskedLines
            lines={["Get a free", "payroll quote"]}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-slate-900"
          />
          <p className="mt-6 max-w-xl text-base sm:text-lg leading-relaxed text-slate-600">
            Three quick steps, with your price on screen the whole time. You will get a written quote the same business
            day, and a CPA will answer any questions about switching.
          </p>

          <QuoteWizard />

          <p className="mt-8 text-sm text-slate-500">
            Prefer to talk? Call{" "}
            <a href={`tel:${SITE.phone}`} className="font-semibold text-emerald-700 hover:underline">{SITE.phoneDisplay}</a>{" "}
            or email{" "}
            <a href={`mailto:${SITE.email}`} className="font-semibold text-emerald-700 hover:underline">{SITE.email}</a>.
          </p>
        </div>
      </section>
    </>
  );
}
